import { ApplicationsGuard } from './applications.guard';

export const guards = [ApplicationsGuard];

export * from './applications.guard';
